/* global axios */
import ApiClient from './ApiClient';

// Relatórios › Leads de anúncio — Api::V2::Accounts::AdReferralLeadsController.
// `since`/`until` são epoch em SEGUNDOS e obrigatórios nos três endpoints.
// Arrays (`channels`, `source_ids`) saem como `channels[]=a&channels[]=b` pelo
// serializer padrão do axios 1.x — é o formato que o Rails lê como array.
class AdReferralLeadsAPI extends ApiClient {
  constructor() {
    super('ad_referral_leads', { accountScoped: true, apiVersion: 'v2' });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  summary(params = {}) {
    return axios.get(`${this.url}/summary`, { params });
  }

  // CSV como texto: o erro (422) também chega como TEXTO — quem lê a mensagem
  // é o `backendErrorMessage` abaixo, que sabe parsear.
  export(params = {}) {
    return axios.get(`${this.url}/export`, { params, responseType: 'text' });
  }
}

// Mensagem que o BACKEND escreveu pro usuário: 422 com `{ error: "<pt_BR>" }`
// (período inválido, exportação grande demais, fuso ausente). No export o corpo
// é string por causa do `responseType: 'text'`, então o JSON é lido à mão.
// Sem mensagem do backend (502 do proxy, HTML, JSON truncado) devolve null e
// quem chama compõe o aviso com o erro técnico do axios — nunca some calado.
export const backendErrorMessage = error => {
  const data = error?.response?.data;
  if (data && typeof data === 'object') {
    return data.error ? String(data.error) : null;
  }
  if (typeof data !== 'string' || !data.trim().startsWith('{')) return null;
  try {
    const parsed = JSON.parse(data);
    return parsed?.error ? String(parsed.error) : null;
  } catch {
    return null;
  }
};

export default new AdReferralLeadsAPI();
